"use client";

import React from "react";
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { useTranslations } from "next-intl";
import { ArrowUpDown } from "lucide-react";
import { ArticleSortType, articleSortTypes } from "@/lib/data/articles";
import { useRouter } from "@/i18n/routing";

type Props = {
  page: number;
  sort: ArticleSortType;
  baseUrl: string;
};

const ArticleSortSelect: React.FC<Props> = ({ page, sort, baseUrl }) => {
  const t = useTranslations("resource");
  const router = useRouter();

  const onChange = (value: ArticleSortType) => {
    const params = new URLSearchParams();
    if (value !== "DATE_DESC") {
      params.set("sort", value);
    }

    if (page > 1) {
      params.set("page", page.toString());
    }

    router.push({
      pathname: baseUrl,
      query: Object.fromEntries(params),
    });
  };
  return (
    <div className="flex items-center justify-end h-full">
      <Select value={sort} onValueChange={onChange}>
        <div>
          <SelectTrigger aria-label={t("sort-by")} className="w-fit lg:w-[200px] font-medium text-sm">
            <div className="flex flex-row items-center gap-2">
              <ArrowUpDown className="size-4 mr-1 lg:mr-0" />
              <p className="hidden lg:block">
                <SelectValue placeholder={t("sort-by")} />
              </p>
            </div>
          </SelectTrigger>
        </div>
        <SelectContent>
          <SelectGroup>
            {articleSortTypes.map((option) => (
              <SelectItem key={option} value={option}>
                {t(`category-sort.${option}`)}
              </SelectItem>
            ))}
          </SelectGroup>
        </SelectContent>
      </Select>
    </div>
  );
};

export default ArticleSortSelect;
